import produce from "immer";
import { UIActions, UPDATE_BACKDROP } from "./action";

export interface UIState
{
    backdrop: {
        show: boolean;
        zIndex: number;
    };
}

const initialState: UIState =
{
    backdrop: {
        show: false,
        zIndex: 99
    }
};

export const reducer = (uiState = initialState, action: UIActions): UIState => produce(uiState, draft =>
{
    switch (action.type)
    {
        case UPDATE_BACKDROP: {
            draft.backdrop.show = action.show;
            if (action.zIndex)
            {
                draft.backdrop.zIndex = action.zIndex;
            }
            break;
        }
    }
});

export const getBackdrop = (state: UIState) => state.backdrop;

export default reducer;